import { Builder } from '@builder.io/sdk';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, EventEmitter, Component, ChangeDetectionStrategy, Input, Output, makeStateKey, Directive, PLATFORM_ID, NgModule } from '@angular/core';
import * as i3$1 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { Subscription, BehaviorSubject } from 'rxjs';
import * as i1$1 from '@angular/platform-browser';

// Modified from @webcomponentsjs but fixed so uglifyjs can run (remove `const` keyword)
// Original source: https://github.com/webcomponents/custom-elements/blob/master/src/native-shim.js
// Issue: https://github.com/webcomponents/webcomponentsjs/issues/749
const _c0 = ["*"];
function BuilderComponentComponent_span_0_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span")(1, "builder-blocks", 3);
    i0.ɵɵlistener("click", function BuilderComponentComponent_span_0_span_1_Template_builder_blocks_click_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onClick($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("key", ctx_r1.key)("model", ctx_r1.model)("prerender", false)("options", ctx_r1.options);
  }
}
function BuilderComponentComponent_span_0_span_2_builder_content_1_builder_blocks_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "builder-blocks", 7);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const content_r5 = ctx_r3.$implicit;
    const meta_r6 = ctx_r3.meta;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("key", ctx_r1.key)("model", ctx_r1.model)("prerender", ctx_r1.prerender)("options", ctx_r1.options)("blocks", content_r5.blocks || content_r5)("breakpoints", content_r5.meta && content_r5.meta.breakpoints || meta_r6 && meta_r6.breakpoints || undefined);
  }
}
function BuilderComponentComponent_span_0_span_2_builder_content_1_ng_content_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "loading"]);
  }
}
function BuilderComponentComponent_span_0_span_2_builder_content_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "builder-content", 5);
    i0.ɵɵlistener("click", function BuilderComponentComponent_span_0_span_2_builder_content_1_Template_builder_content_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.onClick($event));
    })("contentLoad", function BuilderComponentComponent_span_0_span_2_builder_content_1_Template_builder_content_contentLoad_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.load.next($event));
    })("contentError", function BuilderComponentComponent_span_0_span_2_builder_content_1_Template_builder_content_contentError_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.error.next($event));
    });
    i0.ɵɵtemplate(1, BuilderComponentComponent_span_0_span_2_builder_content_1_builder_blocks_1_Template, 1, 6, "builder-blocks", 6)(2, BuilderComponentComponent_span_0_span_2_builder_content_1_ng_content_2_Template, 1, 0, "ng-content", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const content_r5 = ctx.$implicit;
    const loading_r7 = ctx.loading;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("data", ctx_r1.data)("hydrate", ctx_r1.hydrate)("prerender", ctx_r1.prerender)("content", content_r5)("options", ctx_r1.options);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", content_r5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", loading_r7);
  }
}
function BuilderComponentComponent_span_0_span_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtemplate(1, BuilderComponentComponent_span_0_span_2_builder_content_1_Template, 3, 7, "builder-content", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("builderModel", ctx_r1.model);
  }
}
function BuilderComponentComponent_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 1);
    i0.ɵɵtemplate(1, BuilderComponentComponent_span_0_span_1_Template, 2, 4, "span", 2)(2, BuilderComponentComponent_span_0_span_2_Template, 2, 1, "span", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.prerender);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.prerender);
  }
}
if (typeof window !== 'undefined') {
  const anyWindow = window;
  if (!(undefined === anyWindow.Reflect || undefined === anyWindow.customElements || anyWindow.customElements.polyfillWrapFlushCallback)) {
    try {
      const ModifiedHTMLElement = HTMLElement;
      // https://github.com/webcomponents/custom-elements/blame/c078ea4201c82551462ccace1ae91e22b576beb8/src/native-shim.js#L37
      const wrapperForTheName = {
        HTMLElement: function HTMLElement() {
          return Reflect.construct(ModifiedHTMLElement, [], this.constructor);
        }
      };
      anyWindow.HTMLElement = wrapperForTheName['HTMLElement'];
      HTMLElement.prototype = ModifiedHTMLElement.prototype;
      HTMLElement.prototype.constructor = HTMLElement;
      Object.setPrototypeOf(HTMLElement, ModifiedHTMLElement);
    } catch (e) {}
  }
}
const REQUEST = new InjectionToken('REQUEST');
const RESPONSE = new InjectionToken('RESPONSE');
const BUILDER_API_KEY = 'BUILDER_API_KEY'; // new InjectionToken<string>('BUILDER_API_KEY');
const EXPRESS_REQUEST = 'EXPRESS_REQUEST'; // new InjectionToken<Request>('EXPRESS_REQUEST');
const EXPRESS_RESPONSE = 'EXPRESS_RESPONSE'; // new InjectionToken<Response>('EXPRESS_RESPONSE');
let BuilderService = /*#__PURE__*/(() => {
  class BuilderService extends Builder {
    expressRequest;
    expressEngineRequest;
    expressResponse;
    expressEngineResponse;
    http;
    static componentInstances = {};
    autoTrack = !this.isDevelopment;
    // TODO: set this for QA
    get isDevelopment() {
      // Automatic determining of development environment
      return Builder.isIframe || Builder.isBrowser && (location.hostname === 'localhost' || location.port !== '');
    }
    constructor(apiKey, expressRequest, expressEngineRequest, expressResponse, expressEngineResponse, http) {
      super(apiKey, expressEngineRequest || expressRequest, expressEngineResponse || expressResponse);
      this.expressRequest = expressRequest;
      this.expressEngineRequest = expressEngineRequest;
      this.expressResponse = expressResponse;
      this.expressEngineResponse = expressEngineResponse;
      this.http = http;
      if (this.expressEngineRequest) {
        this.expressRequest = this.expressEngineRequest;
      }
      if (this.expressRequest) {
        this.request = this.expressRequest;
      }
      if (this.expressEngineResponse) {
        this.expressResponse = this.expressEngineResponse;
      }
      if (this.expressResponse) {
        this.response = this.expressResponse;
      }
      if (apiKey) {
        this.apiVersion = 'v3';
        this.init(apiKey);
      }
      if (!Builder.isBrowser && !this.request) {
        console.warn('No express request set! Builder cannot target appropriately without this, ' + 'please contact help@builder.io to learn how to set this as required');
      }
    }
    // (override)
    requestUrl(url) {
      if (this.http) {
        return this.http.get(url).toPromise();
      } else {
        return super.requestUrl(url);
      }
    }
    static ɵfac = function BuilderService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderService)(i0.ɵɵinject(BUILDER_API_KEY, 8), i0.ɵɵinject(EXPRESS_REQUEST, 8), i0.ɵɵinject(REQUEST, 8), i0.ɵɵinject(EXPRESS_RESPONSE, 8), i0.ɵɵinject(RESPONSE, 8), i0.ɵɵinject(i1.HttpClient, 8));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BuilderService,
      factory: BuilderService.ɵfac
    });
  }
  return BuilderService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderComponentService = /*#__PURE__*/(() => {
  class BuilderComponentService {
    contentComponentInstance = null;
    contentDirectiveInstance = null;
    static ɵfac = function BuilderComponentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderComponentService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BuilderComponentService,
      factory: BuilderComponentService.ɵfac
    });
  }
  return BuilderComponentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderContentComponent = /*#__PURE__*/(() => {
  class BuilderContentComponent {
    element;
    builderComponentService;
    constructor(element, builderComponentService) {
      this.element = element;
      this.builderComponentService = builderComponentService;
      builderComponentService.contentComponentInstance = this;
    }
    modelName;
    useHtml = false;
    data = {};
    hydrate = true;
    prerender = true;
    set content(content) {
      const currentContent = this._content;
      this._content = content;
      const {
        contentDirectiveInstance
      } = this.builderComponentService;
      if (!currentContent && content && contentDirectiveInstance) {
        if (!contentDirectiveInstance.requesting) {
          contentDirectiveInstance.reset();
        }
      }
    }
    get content() {
      return this._content;
    }
    _content;
    findAndRunScripts() {
      if (!Builder.isBrowser) {
        return;
      }
      const el = this.element.nativeElement;
      if (el) {
        const scripts = el.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
          const script = scripts[i];
          if (script.src) {
            const newScript = document.createElement('script');
            newScript.async = true;
            newScript.src = script.src;
            document.head.appendChild(newScript);
          } else {
            try {
              new Function(script.innerText)();
            } catch (error) {
              console.warn('Builder custom code component error:', error);
            }
          }
        }
      }
    }
    options = null;
    contentLoad = new EventEmitter();
    contentError = new EventEmitter();
    get editingMode() {
      return Builder.editingPage;
    }
    ngOnInit() {
      const modelName = this.element.nativeElement && this.element.nativeElement.getAttribute && this.element.nativeElement.getAttribute('builder-model');
      if (modelName) {
        // FIXME: doesn't work on server!
        this.modelName = modelName;
        BuilderService.componentInstances[modelName] = this;
      }
    }
    ngOnDestroy() {
      if (this.modelName) {
        if (BuilderService.componentInstances[this.modelName] === this) {
          delete BuilderService.componentInstances[this.modelName];
        }
      }
    }
    static ɵfac = function BuilderContentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderContentComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BuilderComponentService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BuilderContentComponent,
      selectors: [["builder-content"]],
      inputs: {
        useHtml: "useHtml",
        data: "data",
        hydrate: "hydrate",
        prerender: "prerender",
        content: "content",
        options: "options"
      },
      outputs: {
        contentLoad: "contentLoad",
        contentError: "contentError"
      },
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function BuilderContentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
  return BuilderContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderContentService = /*#__PURE__*/(() => {
  class BuilderContentService {
    componentInstance = null;
    directiveInstance = null;
    static ɵfac = function BuilderContentService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderContentService)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: BuilderContentService,
      factory: BuilderContentService.ɵfac
    });
  }
  return BuilderContentService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderContentDirective = /*#__PURE__*/(() => {
  class BuilderContentDirective {
    _viewContainer;
    renderer;
    builder;
    builderComponentService;
    transferState;
    router;
    get component() {
      // return BuilderService.componentInstances[this._context.model as string];
      return this.builderComponentService.contentComponentInstance;
    }
    lastContentId = null;
    lastUrl = null;
    subscriptions = new Subscription();
    _context = new BuilderContentContext();
    _templateRef = null;
    _viewRef = null;
    // private _repeat = false;
    match;
    matchId = '';
    clickTracked = false;
    hydrated = false;
    constructor(_viewContainer, renderer, builder, builderComponentService, transferState, templateRef, router) {
      this._viewContainer = _viewContainer;
      this.renderer = renderer;
      this.builder = builder;
      this.builderComponentService = builderComponentService;
      this.transferState = transferState;
      this.router = router;
      builderComponentService.contentDirectiveInstance = this;
      this._templateRef = templateRef;
    }
    // TODO: pass this option down from builder-component
    reloadOnRoute = true;
    contentSubscription = null;
    stateKey;
    requesting = true;
    reset() {
      // TODO: listen to any target change? This just updates target?
      // TODO: track last fetched ID and don't replace dom if on new url the content is the same...
      this.clickTracked = false;
      this.hydrated = false;
      // Verify the route didn't result in this component being destroyed
      this.request();
    }
    ngOnInit() {
      Builder.nextTick(() => {
        this.request();
      });
      if (this.router) {
        this.subscriptions.add(this.router.events.subscribe(event => {
          // TODO: this doesn't trigger
          if (event instanceof NavigationEnd) {
            if (this.reloadOnRoute) {
              const viewRef = this._viewRef;
              if (viewRef && viewRef.destroyed) {
                return;
              }
              if (this.url !== this.lastUrl) {
                this.reset();
              }
            }
          }
        }));
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
      if (this.contentSubscription) {
        this.contentSubscription.unsubscribe();
      }
    }
    // TODO: have another option for this or get from metadata
    // @Input()
    // set modelMultiple(repeat: boolean) {
    //   this._repeat = repeat;
    // }
    // @HostListener('click')
    onClick(event) {
      if (this.matchId && !this.hydrated) {
        const match = this.match;
        if (this.builder.autoTrack) {
          this.builder.trackInteraction(this.matchId, match && match.variationId, this.clickTracked, event, {
            content: match
          });
        }
        this.clickTracked = true;
      }
      // TODO: only in editor mode
      // TODO: put messaging on builder class
      if (document.body.classList.contains('builder-editing')) {
        if (this.matchId) {
          // TODO: get event object and pass mouse coordinages
          window.parent.postMessage({
            type: 'builder.clickContent',
            data: {
              id: this.matchId,
              model: this._context.model
            }
          }, '*');
        } else {
          window.parent.postMessage({
            type: 'builder.clickModel',
            data: {
              model: this._context.model
            }
          }, '*');
        }
      }
    }
    get stateKeyString() {
      return 'builder:' + this._context.model + ':' + (this.reloadOnRoute ? this.url : '');
    }
    // TODO: limit?
    // TODO: context with index, etc
    set builderModel(model) {
      if (!model) {
        return;
      }
      this._context.model = model;
      this._updateView();
      this.stateKey = makeStateKey(this.stateKeyString);
      // this.request();
      const rootNode = this._viewRef.rootNodes[0];
      this.renderer.setAttribute(rootNode, 'builder-model', model);
      this.renderer.setAttribute(rootNode, 'builder-model-name', model.replace(/-/g, ' '));
      this.renderer.listen(rootNode, 'click', event => this.onClick(event));
    }
    get url() {
      const location = this.builder.getLocation();
      return location.pathname || ''; // + (location.search || '');
    }
    // TODO: service for this
    request() {
      this.lastUrl = this.url;
      this.requesting = true;
      if (this.component && !this.component.prerender) {
        return;
      }
      const viewRef = this._viewRef;
      if (viewRef && viewRef.destroyed) {
        return;
      }
      let receivedFirstResponse = false;
      const model = this._context.model;
      const options = this.component && this.component.options;
      const initialContent = this.component && this.component.content || Builder.isBrowser &&
      // firstEverLoad &&
      this.transferState && this.transferState.get(this.stateKeyString, null);
      // firstEverLoad = false;
      // TODO: if not multipe
      if (this.contentSubscription) {
        // TODO: cancel a request if one is pending... or set some kind of flag
        this.contentSubscription.unsubscribe();
      }
      const hydrate = Builder.isBrowser && this.component && this.component.hydrate;
      const key = Builder.isEditing || !this.reloadOnRoute ? model : `${model}:${this.url}`;
      const subscription = this.contentSubscription = this.builder.queueGetContent(model, {
        initialContent,
        key,
        ...options,
        prerender: true,
        static: !hydrate
      }).subscribe(result => {
        let match = result[0];
        // Cancel handling request if new one created or they have been canceled, to avoid race conditions
        // if multiple routes or other events happen
        if (this.contentSubscription !== subscription) {
          if (!receivedFirstResponse) {}
          return;
        }
        if (match && match.id === this.lastContentId) {
          return;
        }
        this.lastContentId = match && match.id;
        if (this.transferState && !Builder.isBrowser) {
          this.transferState.set(this.stateKeyString, result);
        }
        // tslint:disable-next-line:no-non-null-assertion
        const viewRef = this._viewRef;
        if (viewRef.destroyed) {
          this.subscriptions.unsubscribe();
          if (this.contentSubscription) {
            this.contentSubscription.unsubscribe();
          }
          return;
        }
        const rootNode = Builder.isBrowser && viewRef.rootNodes[0];
        if (Builder.isBrowser) {
          if (rootNode) {
            if (rootNode && rootNode.classList.contains('builder-editor-injected')) {
              viewRef.detach();
              return;
            }
          }
        }
        // FIXME: nasty hack to detect secondary updates vs original. Build proper support into JS SDK
        // if (this._context.loading || result.length > viewRef.context.results.length) {
        this._context.loading = false;
        const search = this.builder.getLocation().search || '';
        // TODO: how handle singleton vs multiple
        if (!match && search.includes('builder.preview=' + this._context.model)) {
          match = {
            id: 'preview',
            name: 'Preview',
            data: {}
          };
        }
        if (this.component) {
          this.component.contentLoad.next(match);
        } else {
          console.warn('No component!');
        }
        if (match) {
          const rootNode = this._viewRef.rootNodes[0];
          this.matchId = match.id;
          this.renderer.setAttribute(rootNode, 'builder-content-entry-id', match.id);
          this.match = match;
          viewRef.context.$implicit = match.data;
          viewRef.context.meta = match.meta;
          // viewRef.context.results = result.map(item => ({ ...item.data, $id: item.id }));
          if (!hydrate && this.builder.autoTrack) {
            this.builder.trackImpression(match.id, match.variationId, undefined, {
              content: match
            });
          }
        }
        if (!viewRef.destroyed) {
          viewRef.detectChanges();
          if (this.builderComponentService.contentComponentInstance && this.builderComponentService.contentComponentInstance.prerender && Builder.isBrowser && Builder.isStatic) {
            Builder.nextTick(() => {
              if (this.builderComponentService.contentComponentInstance) {
                this.builderComponentService.contentComponentInstance.findAndRunScripts();
              }
            });
          }
          // TODO: it's possible we don't want anything below to run if this has been destroyed
          if (match && match.data && match.data.animations && Builder.isBrowser && !hydrate) {
            Builder.nextTick(() => {
              Builder.animator.bindAnimations(match.data.animations);
            });
          }
        }
        if (!receivedFirstResponse) {
          receivedFirstResponse = true;
        }
      }, error => {
        if (this.component) {
          this.component.contentError.next(error);
        } else {
          console.warn('No component!');
        }
        if (!receivedFirstResponse) {
          // TODO: how to zone error
          receivedFirstResponse = true;
        }
      });
    }
    _updateView() {
      if (this._context.model) {
        this._viewContainer.clear();
        if (this._templateRef) {
          this._viewRef = this._viewContainer.createEmbeddedView(this._templateRef, this._context);
        }
      }
    }
    static ɵfac = function BuilderContentDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderContentDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(BuilderService), i0.ɵɵdirectiveInject(BuilderComponentService), i0.ɵɵdirectiveInject(i0.TransferState, 8), i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i3.Router, 8));
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: BuilderContentDirective,
      selectors: [["", "builderModel", ""]],
      inputs: {
        reloadOnRoute: "reloadOnRoute",
        builderModel: "builderModel"
      },
      features: [i0.ɵɵProvidersFeature([BuilderContentService])]
    });
  }
  return BuilderContentDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BuilderContentContext {
  $implicit;
  match;
  model;
  loading = true;
  results = [];
  meta;
}
let BuilderBlocksComponent = /*#__PURE__*/(() => {
  class BuilderBlocksComponent {
    domSanitizer;
    builder;
    blocks;
    child = false;
    prerender = true;
    model = '';
    key = '';
    options = null;
    // @deprecated
    field = '';
    breakpoints;
    constructor(domSanitizer, builder) {
      this.domSanitizer = domSanitizer;
      this.builder = builder;
    }
    lastInnerHtml = '';
    lastInnerHtmlSanitized = null;
    get hasNoChildren() {
      return !(this.blocks && (this.blocks.length || this.blocks.html));
    }
    get arrayBlocks() {
      return Array.isArray(this.blocks);
    }
    get innerHtml() {
      const html = this._innerHtml;
      if (html === this.lastInnerHtml) {
        return this.lastInnerHtmlSanitized || '';
      }
      this.lastInnerHtml = html;
      this.lastInnerHtmlSanitized = this.domSanitizer.bypassSecurityTrustHtml(html);
      return this.lastInnerHtmlSanitized;
    }
    get _innerHtml() {
      // TODO: pass options too
      if (!this.prerender || Builder.isEditing) {
        return `<builder-component-element prerender="false" ${!this.model ? '' : `name="${this.model}"`}></builder-component-element>`;
      }
      const elStr = `<builder-component-element prerender="false" ${!this.model ? '' : `name="${this.model}"`}></builder-component-element>`;
      if (this.arrayBlocks || !this.blocks) {
        return elStr;
      }
      if (!this.blocks.html) {
        return elStr;
      }
      const css = this.blocks.css;
      let html = this.blocks.html;
      if (this.breakpoints) {
        if (this.breakpoints.small) {
          html = html.replace(/max-width:640/g, `max-width:${this.breakpoints.small}`);
        }
        if (this.breakpoints.medium) {
          html = html.replace(/max-width:991/g, `max-width:${this.breakpoints.medium}`);
        }
      }
      if (css) {
        html = `<style class="builder-styles">${css}</style>` + html;
      }
      return `<builder-component-element key="${this.key || this.model}" options='${JSON.stringify(this.options || null // TODO: HTML encode
      )}' prerender="false" rev="${this.blocks.rev || ''}" ${!this.model ? '' : `name="${this.model}"`}>${html}</builder-component-element>`;
    }
    trackByFn(index, value) {
      // TODO: possibly json-stable-stringify
      return value.id || value.component && value.component.id || JSON.stringify(value);
    }
    static ɵfac = function BuilderBlocksComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderBlocksComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer), i0.ɵɵdirectiveInject(BuilderService));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BuilderBlocksComponent,
      selectors: [["builder-blocks"]],
      inputs: {
        blocks: "blocks",
        child: "child",
        prerender: "prerender",
        model: "model",
        key: "key",
        options: "options",
        field: "field",
        breakpoints: "breakpoints"
      },
      decls: 2,
      vars: 1,
      consts: [[1, "builder-blocks", "builder-blocks-html"], [3, "innerHTML"]],
      template: function BuilderBlocksComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵelement(1, "div", 1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.innerHtml, i0.ɵɵsanitizeHtml);
        }
      },
      changeDetection: 0
    });
  }
  return BuilderBlocksComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BuilderBlocksOutletComponent = /*#__PURE__*/(() => {
  class BuilderBlocksOutletComponent {
    domSanitizer;
    builderBlock;
    builderState;
    blocks;
    renderOnChange = true;
    dataPath;
    lastInnerHtml = '';
    lastInnerHtmlSanitized;
    get options() {
      return {
        child: true,
        parentElementId: this.builderBlock.id,
        blocks: this.blocks,
        dataPath: this.dataPath
      };
    }
    get key() {
      return this.builderBlock.id + this.dataPath;
    }
    get innerHtml() {
      const html = this._innerHtml;
      if (html === this.lastInnerHtml) {
        return this.lastInnerHtmlSanitized || '';
      }
      this.lastInnerHtml = html;
      this.lastInnerHtmlSanitized = this.domSanitizer.bypassSecurityTrustHtml(html);
      return this.lastInnerHtmlSanitized;
    }
    get _innerHtml() {
      return `<builder-blocks-slot key="${this.key}"></builder-blocks-slot>`;
    }
    constructor(domSanitizer) {
      this.domSanitizer = domSanitizer;
    }
    ngAfterViewInit() {
      if (Builder.isBrowser) {
        this.triggerstateChange();
      }
    }
    async triggerstateChange() {
      const query = `builder-blocks-slot[key="${this.key}"]`;
      const element = document.querySelector(query);
      if (element) {
        await customElements.whenDefined('builder-blocks-slot');
        element.setProps(this.options, this.builderState);
      }
    }
    ngOnChanges(changes) {
      if (changes.blocks && this.renderOnChange) {
        this.triggerstateChange();
      }
    }
    static ɵfac = function BuilderBlocksOutletComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderBlocksOutletComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BuilderBlocksOutletComponent,
      selectors: [["builder-blocks-outlet"]],
      inputs: {
        builderBlock: "builderBlock",
        builderState: "builderState",
        blocks: "blocks",
        renderOnChange: "renderOnChange",
        dataPath: "dataPath"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 1,
      consts: [[3, "innerHTML"]],
      template: function BuilderBlocksOutletComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelement(0, "div", 0);
        }
        if (rf & 2) {
          i0.ɵɵproperty("innerHTML", ctx.innerHtml, i0.ɵɵsanitizeHtml);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
  return BuilderBlocksOutletComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO remove hardcoded version, maybe a release tag?
const ANGULAR_LATEST_VERSION = '1.3.51';
const SCRIPT_ID = 'builder-wc-script';
function omit(obj, ...values) {
  const newObject = Object.assign({}, obj);
  for (const key of values) {
    delete newObject[key];
  }
  return newObject;
}
let wcScriptInserted = false;
const NAVIGATION_TIMEOUT_DEFAULT = 1000;
function delay(duration, resolveValue) {
  return new Promise(resolve => setTimeout(() => resolve(resolveValue), duration));
}
let BuilderComponentComponent = /*#__PURE__*/(() => {
  class BuilderComponentComponent {
    viewContainer;
    elementRef;
    builderService;
    router;
    model;
    set name(name) {
      this.model = name;
    }
    handleRouting = true;
    reloadOnRoute = true;
    load = new EventEmitter();
    route = new EventEmitter();
    error = new EventEmitter();
    content = null;
    options = null;
    data = {};
    context = {};
    hydrate = true;
    prerender = true;
    // Sometimes user will have slow connection and when we are using Resolver on target route
    // then, application will be fully reloaded. In that case set it to false to avoid full-reload navigation.
    navigationTimeout = NAVIGATION_TIMEOUT_DEFAULT;
    subscriptions = new Subscription();
    visible = new BehaviorSubject(true);
    get url() {
      const location = this.builderService.getLocation();
      return location.pathname || '';
    }
    get key() {
      const key = Builder.isEditing || !this.reloadOnRoute ? this.model : `${this.model}:${this.url}`;
      return key;
    }
    constructor(viewContainer, elementRef, builderService, router) {
      this.viewContainer = viewContainer;
      this.elementRef = elementRef;
      this.builderService = builderService;
      this.router = router;
    }
    async ensureWCScriptLoaded() {
      if (!Builder.isBrowser || wcScriptInserted || document.getElementById(SCRIPT_ID)) {
        return;
      }
      function getQueryParam(url, variable) {
        const query = url.split('?')[1] || '';
        const vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
          const pair = vars[i].split('=');
          if (decodeURIComponent(pair[0]) === variable) {
            return decodeURIComponent(pair[1]);
          }
        }
        return null;
      }
      const script = document.createElement('script');
      const wcVersion = getQueryParam(location.href, 'builder.wcVersion') || ANGULAR_LATEST_VERSION;
      script.id = SCRIPT_ID;
      // TODO: detect builder.wcVersion and if customEleemnts exists and do
      // dynamic versions and lite here
      script.src = `https://cdn.builder.io/js/webcomponents@${wcVersion || 'latest'}/dist/system/angular/builder-webcomponents-async.js`;
      script.async = true;
      wcScriptInserted = true;
      return new Promise((resolve, reject) => {
        script.addEventListener('load', resolve);
        script.addEventListener('error', e => reject(e.error));
        document.head.appendChild(script);
      });
    }
    async ensureWcLoadedAndUpdate() {
      await this.ensureWCScriptLoaded();
      const {
        onBuilderWcLoad
      } = window;
      if (onBuilderWcLoad) {
        onBuilderWcLoad(BuilderWC => {
          const builder = BuilderWC.builder;
          builder.apiKey = this.builderService.apiKey;
          builder.canTrack = this.builderService.canTrack;
          builder.setUserAttributes(omit(this.builderService.getUserAttributes(), 'urlPath'));
          this.builderService.userAttributesChanged.subscribe(attrs => builder.setUserAttributes(attrs));
          this.triggerstateChange();
        });
      }
    }
    ngOnInit() {
      if (this.router && this.reloadOnRoute) {
        // TODO: should the inner function return reloadOnRoute?
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      }
      if (Builder.isBrowser) {
        if (this.router) {
          this.subscriptions.add(this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
              if (this.reloadOnRoute) {
                // Force reload component
                this.visible.next(false);
                Builder.nextTick(() => {
                  this.visible.next(true);
                });
              }
            }
          }));
        }
        this.subscriptions.add(this.load.subscribe(async value => {
          // TODO: this may run constantly when editing - check on this, not
          // end of world but not ideal for perf
          this.viewContainer.detach();
          if (Builder.isEditing || value && value.data && this.hydrate !== false) {
            await this.ensureWcLoadedAndUpdate();
          }
        }));
      }
      if (Builder.isBrowser && (this.hydrate !== false || Builder.isEditing)) {
        this.ensureWcLoadedAndUpdate();
      }
    }
    async triggerstateChange() {
      const query = `builder-component-element[name="${this.model}"]`;
      const element = document.querySelector(query);
      if (element) {
        customElements.whenDefined('builder-component-element').then(() => {
          element.setState(this.data);
          element.setContext(this.context);
        });
      }
    }
    ngOnChanges(changes) {
      if (changes.data) {
        this.triggerstateChange();
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    // TODO: this should be in BuilderBlocks
    async onClick(event) {
      if (!this.handleRouting) {
        return;
      }
      if (event.button !== 0 || event.ctrlKey || event.defaultPrevented) {
        // If this is a non-left click, or the user is holding ctr/cmd, or the url is absolute,
        // or if the link has a target attribute, don't route on the client and let the default
        // href property handle the navigation
        return;
      }
      const hrefTarget = this.findHrefTarget(event);
      if (!hrefTarget) {
        return;
      }
      // target="_blank" or target="_self" etc
      if (hrefTarget.target) {
        return;
      }
      let href = hrefTarget.getAttribute('href');
      if (!href) {
        return;
      }
      if (href.startsWith('javascript:')) {
        return;
      }
      const routeEvent = {
        url: href,
        anchorNode: hrefTarget,
        preventDefault() {
          this.defaultPrevented = true;
        },
        defaultPrevented: false
      };
      this.route.next(routeEvent);
      if (routeEvent.defaultPrevented) {
        event.preventDefault();
        return;
      }
      if (event.metaKey) {
        return;
      }
      if (!this.isRelative(href)) {
        const converted = this.convertToRelative(href);
        if (converted) {
          href = converted;
        } else {
          return;
        }
      }
      if (!this.router) {
        return;
      }
      // Otherwise if this url is relative, navigate on the client
      event.preventDefault();
      // Attempt to route on the client
      let success = null;
      const routePromise = this.router.navigateByUrl(href);
      const useNavigationTimeout = !(typeof this.navigationTimeout === 'boolean' && !this.navigationTimeout);
      const timeoutPromise = delay(typeof this.navigationTimeout === 'number' ? this.navigationTimeout : NAVIGATION_TIMEOUT_DEFAULT, false);
      try {
        const promiseRace = useNavigationTimeout ? [timeoutPromise, routePromise] : [routePromise];
        success = await Promise.race(promiseRace);
      } finally {
        // This is in a click handler so it will only run on the client
        if (success) {
          // If successful scroll the window to the top
          window.scrollTo(0, 0);
        } else {
          // Otherwise handle the routing with a page refresh on failure. Angular, by deafult
          // if it fails to load a URL (e.g. if an API request failed when loading it), instead
          // of navigating to the new page to tell the user that their click did something but
          // the resulting page has an issue, it instead just silently fails and shows the user
          // nothing. Lets make sure we route to the new page. In some cases this even brings the
          // user to a correct and valid page anyway
          location.href = `${location.protocol}//${location.host}${href}`;
        }
      }
    }
    isRelative(href) {
      return !href.match(/^(\/\/|https?:\/\/)/i) &&
      // Handle Mailto and Tel links
      !href.startsWith('tel:') && !href.startsWith('mailto:') &&
      // Handle local hash links
      !href.startsWith('#');
    }
    // Attempt to convert an absolute url to relative if possible (aka if the hosts match)
    convertToRelative(href) {
      const currentUrl = new URL(location.href);
      const hrefUrl = new URL(href);
      if (currentUrl.host === hrefUrl.host) {
        const relativeUrl = hrefUrl.pathname + (hrefUrl.search ? hrefUrl.search : '');
        return relativeUrl;
      }
    }
    findHrefTarget(event) {
      let element = event.target;
      while (element) {
        if (element instanceof HTMLAnchorElement && element.getAttribute('href')) {
          return element;
        }
        if (element === event.currentTarget) {
          break;
        }
        element = element.parentElement;
      }
      return null;
    }
    static ɵfac = function BuilderComponentComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderComponentComponent)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(BuilderService), i0.ɵɵdirectiveInject(i3.Router, 8));
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: BuilderComponentComponent,
      selectors: [["builder-component"]],
      inputs: {
        model: "model",
        name: "name",
        handleRouting: "handleRouting",
        reloadOnRoute: "reloadOnRoute",
        content: "content",
        options: "options",
        data: "data",
        context: "context",
        hydrate: "hydrate",
        prerender: "prerender",
        navigationTimeout: "navigationTimeout"
      },
      outputs: {
        load: "load",
        route: "route",
        error: "error"
      },
      features: [i0.ɵɵProvidersFeature([BuilderComponentService]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [["class", "builder-component-wrap", 4, "ngIf"], [1, "builder-component-wrap"], [4, "ngIf"], ["field", "blocks", 3, "click", "key", "model", "prerender", "options"], [3, "data", "hydrate", "prerender", "content", "options", "click", "contentLoad", "contentError", 4, "builderModel"], [3, "click", "contentLoad", "contentError", "data", "hydrate", "prerender", "content", "options"], ["field", "blocks", 3, "key", "model", "prerender", "options", "blocks", "breakpoints", 4, "ngIf"], ["field", "blocks", 3, "key", "model", "prerender", "options", "blocks", "breakpoints"]],
      template: function BuilderComponentComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵtemplate(0, BuilderComponentComponent_span_0_Template, 3, 2, "span", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx.visible));
        }
      },
      dependencies: [i3$1.NgIf, BuilderContentComponent, BuilderBlocksComponent, BuilderContentDirective, i3$1.AsyncPipe],
      styles: ["[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
  return BuilderComponentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
Builder.isStatic = true;
const directives = [BuilderContentDirective];
const components = [BuilderContentComponent, BuilderBlocksComponent, BuilderComponentComponent, BuilderBlocksOutletComponent];
let BuilderModule = /*#__PURE__*/(() => {
  class BuilderModule {
    platformId;
    constructor(injector, platformId) {
      this.platformId = platformId;
      if (isPlatformBrowser(platformId)) {
        // This cannot use a normal import, via https://github.com/angular/angular/issues/24551
        // Cannot use require, so use import. This otherwise breaks at runtime
        import('@angular/elements').then(({
          createCustomElement
        }) => {
          for (const component of Builder.components) {
            if (component.class && component.type === 'angular' && component.tag && typeof customElements.get(component.tag) === 'undefined') {
              try {
                const Element = createCustomElement(component.class, {
                  injector
                });
                // Register the custom element with the browser.
                customElements.define(component.tag, Element);
              } catch (err) {
                console.warn('Could not make angular element:', component.class);
              }
            }
          }
        });
      }
    }
    static forRoot(apiKey) {
      return {
        ngModule: BuilderModule,
        providers: [{
          provide: BUILDER_API_KEY,
          useValue: apiKey
        }]
      };
    }
    static ɵfac = function BuilderModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || BuilderModule)(i0.ɵɵinject(i0.Injector), i0.ɵɵinject(PLATFORM_ID));
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: BuilderModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [BuilderService, BuilderContentService, BuilderComponentService],
      imports: [CommonModule]
    });
  }
  return BuilderModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function BuilderBlock(options) {
  options.type = 'angular';
  return Builder.Component(options);
}

/**
 * Generated bundle index. Do not edit.
 */

export { BUILDER_API_KEY, BuilderBlock, BuilderBlocksComponent, BuilderBlocksOutletComponent, BuilderComponentComponent, BuilderContentComponent, BuilderContentDirective, BuilderModule, BuilderService, EXPRESS_REQUEST, EXPRESS_RESPONSE };
